import styled from 'styled-components';
import Row from '../../Common/Row';
import {
  KPI_EXTENDED_ROW_HEIGHT,
  KPI_ROW_HEIGHT,
} from './KpiRowRight/constants';

const KpiRowElement = styled(Row)<{
  isLastRow?: boolean;
  isExtended?: boolean;
  isHighlighted?: boolean;
  isHovered?: boolean;
}>`
  height: ${(props) =>
    props.isExtended
      ? KPI_ROW_HEIGHT + KPI_EXTENDED_ROW_HEIGHT
      : KPI_ROW_HEIGHT}px;

  background-color: ${(props) =>
    props.isHighlighted
      ? 'var(--color-avatar-2-bg)'
      : props.isExtended
        ? 'var(--color-bg-smoke)'
        : props.isHovered
          ? 'var(--color-bg-selected)'
          : undefined};

  transition: all 0.2s ease;

  .showOnMouseOver {
    visibility: hidden;
  }

  &:hover {
    .showOnMouseOver {
      visibility: visible;
      width: unset;
    }
  }
`;

export default KpiRowElement;
